import { store } from '../../store';
import { setDisplayReturnMethod } from '../../actions/retailerSettings';
import { ReturnDateViewType } from '../../constants/enums';

export const retailerSettingsServiceFunction = () => {
  const {
    retailerSettings,
    returnsSettings,
    page: { productType, locale },
  } = store.getState();
  const requiredConditions = {};
  const currentProduct = productType;
  const settings = returnsSettings?.[currentProduct] || retailerSettings?.[currentProduct];
  const exchangeEnabled =
    settings?.product_options && settings?.product_options.indexOf('exchange') !== -1;
  const styles = returnsSettings?.branding || retailerSettings.branding;
  const brand = retailerSettings;
  const retailerName = retailerSettings?.name?.toLowerCase();
  const displayName = retailerSettings.display_name;
  const returnReasonEligibility = settings?.validation.return_reason_eligibility || {};
  const disabled = settings?.disabled;
  const product = settings?.validation.return_type === 'repairs' ? 'repairs' : 'returns';
  const headerStyle = settings?.headerStyle || 'CenterMenuCenterLogo';
  const multiOrder = settings?.validation.multi_order || false;
  const skipLogin = returnsSettings?.[product]?.skipLogin || false;
  const disableItemCancel = returnsSettings?.[product]?.disableItemCancel || false;
  const productRecommendations = returnsSettings?.[product]?.product_recommendations || null;
  const faviconUrl = retailerSettings?.favicon_url;
  const returnType = settings?.validation?.returnType || 'full_returns';
  const banner = settings?.banner;
  const isRetailerDisabled = settings?.retailerDisabled;
  const isSimpleReturnsEnhanced = settings?.isSimpleReturnsEnhanced;

  const getIsRetailerDisabled = () => isRetailerDisabled;

  const setShowReturnAddressFn = (showAddress) => {
    store.dispatch(setDisplayReturnMethod(showAddress));
  };

  const getShowReturnAddress = () => store.getState()?.retailerSettings?.displayReturnMethod;

  const setRequiredConditions = (condition, value) => {
    requiredConditions[condition] = value;
  };

  const deleteRequiredCondition = (condition) => {
    if (typeof requiredConditions[condition] !== 'undefined') {
      delete requiredConditions[condition];
    }
  };

  const areAllConditionsChecked = (store) => {
    const reqConditionsChecked = Object.keys(requiredConditions).every(
      (key) => requiredConditions[key],
    );
    const {
      page: { productType },
      returnsSettings: { [productType]: { attestation } = {} } = {},
      returnSubmission: { attestation: attestationData } = {},
    } = store.getState();
    if (attestation && attestation.enabled && attestation.requiredFields) {
      const reqFieldsFilled = attestation.requiredFields.every((field) => attestationData[field]);
      return reqFieldsFilled && reqConditionsChecked;
    }
    return reqConditionsChecked;
  };

  const getRequiredConditions = () => requiredConditions;

  const getProduct = () => product;

  const getIsExchangeEnabled = () => exchangeEnabled;

  const getBrand = () => brand;

  const getReturnType = () => returnType;

  const getHeaderStyle = () => headerStyle;

  const getSettings = () => settings;

  const getName = () => retailerName;

  const getDisplayName = () => displayName;

  const getStyle = () => styles;

  const getHeader = () => brand.brand_logo;

  const getNav = () => brand?.header?.menu || [];

  const getBanner = () => banner;

  const getReturnReasonEligibility = () => returnReasonEligibility;

  const getDisabled = () => disabled;

  const getIsMultiOrder = () => multiOrder;

  const getSkipLogin = () => skipLogin;

  const getItemCancelDisabled = () => disableItemCancel;

  const getProductRecommendationSettings = () => productRecommendations;

  const productRecommendationsEnabled = () => productRecommendations?.locales.indexOf(locale) > -1;

  const mergeObjects = (obj1, obj2) => {
    const obj = JSON.parse(JSON.stringify(obj1));

    Object.keys(obj2).forEach((key) => {
      if (obj2[key] && !obj1[key]) {
        obj[key] = obj2[key];
      }
    });
    return obj;
  };

  const getFaviconUrl = () => faviconUrl;

  const getIsSimpleReturns = () => returnType === 'simple_returns';

  const getIsSimpleReturnsBasic = () => getIsSimpleReturns() && !isSimpleReturnsEnhanced;

  const getIsSimpleReturnsEnhanced = () => getIsSimpleReturns() && isSimpleReturnsEnhanced;

  const getReturnDateViewType = () => settings?.returnByDate || ReturnDateViewType.Default;

  return {
    getBrand,
    getBanner,
    getHeaderStyle,
    getSettings,
    getName,
    getDisplayName,
    getStyle,
    getHeader,
    getNav,
    getReturnReasonEligibility,
    getProduct,
    getIsExchangeEnabled,
    getDisabled,
    getIsMultiOrder,
    getSkipLogin,
    getItemCancelDisabled,
    getProductRecommendationSettings,
    productRecommendationsEnabled,
    getFaviconUrl,
    getReturnType,
    mergeObjects,
    setShowReturnAddress: setShowReturnAddressFn,
    getShowReturnAddress,
    setRequiredConditions,
    deleteRequiredCondition,
    areAllConditionsChecked,
    getRequiredConditions,
    getIsRetailerDisabled,
    getIsSimpleReturns,
    getIsSimpleReturnsBasic,
    getIsSimpleReturnsEnhanced,
    getReturnDateViewType,
  };
};

export const retailerSettingsService = retailerSettingsServiceFunction();
